import { FC } from 'react';

import { useTrackActivePinChanged } from './internal/hooks/useTrackActivePinChanged';
import { useTrackClustersChanged } from './internal/hooks/useTrackClustersChanged';
import { useUpdatePinMarkup } from './internal/hooks/useUpdatePinMarkup';

export const MapActivePinUpdater: FC = () => {
  // Изменился активный кластер
  useTrackActivePinChanged();

  // Произошел перезапрос кластеров, нужно не потерять активный пин
  useTrackClustersChanged();

  // Для пинов без балуна рисуем активное состояние - это просто <div> поверх пина, так же сделано для ховера
  useUpdatePinMarkup();

  return null;
};
